import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as MarketplaceService from '_services/marketplace-service';

const initialState = {
    createProduct: null,
    createProductStatus: 'idle',
    createProductError: null,

    distribution: null,
    distributionStatus: 'idle',
    distributionError: null,

    pricing: null,
    pricingStatus: 'idle',
    pricingError: null,

    status: 'idle',
    error: null,
};

/* post new information */
export const createProduct = createAsyncThunk('createProduct/createProduct', async (product) => {
    return MarketplaceService.createProduct(product);
});

/* post distribution information */
export const updateDistributionInformation = createAsyncThunk('createProduct/updateDistributionInformation', async (params) => {
    return MarketplaceService.updateProduct(params);
});

export const updatePricingInformation = createAsyncThunk('createProduct/updatePricingInformation', async (params) => {
    return MarketplaceService.updateProduct(params);
});

const createProductSlice = createSlice({
    name: 'createProduct',
    initialState,
    reducers: {
        reset: (state) => initialState,
        editProduct: (state, action) => {
            state.createProduct = action.payload;
        },
        resetCreateProductStatus: (state) => {
            state.createProductStatus = 'idle';
            state.status = 'idle';
            state.distribution = null;
        },
        editDistribution: (state, action) => {
            state.distribution = action.payload;
        },
        editPricing: (state, action) => {
            state.pricing = action.payload;
        },
        resetCreateProduct: (state) => {
            state.createProduct = null;
            state.createProductStatus = 'idle';
            state.createProductError = null;
            state.distribution = null;
            state.distributionStatus = 'idle';
            state.distributionError = null;
            state.pricing = null;
            state.pricingStatus = 'idle';
            state.pricingError = null;
        },
        resetProduct: (state) => {
            state.createProduct = null
        }
    },
    extraReducers: {
        [createProduct.pending]: (state, action) => {
            return {
                ...state,
                createProductStatus: 'loading',
            }
        },
        [createProduct.fulfilled]: (state, action) => {
            return {
                ...state,
                createProductStatus: 'succeeded',
            }
        },
        [createProduct.rejected]: (state, action) => {
            return {
                ...state,
                createProductStatus: 'failed',
                createProductError: action.error.message,
            }
        },
        [updateDistributionInformation.pending]: (state, action) => {
            return {
                ...state,
                distributionStatus: 'loading',
            }
        },
        [updateDistributionInformation.fulfilled]: (state, action) => {
            return {
                ...state,
                distributionStatus: 'succeeded',
            }
        },
        [updateDistributionInformation.rejected]: (state, action) => {
            return {
                ...state,
                distributionStatus: 'failed',
                distributionError: action.error.message,
            }
        },
        [updatePricingInformation.pending]: (state, action) => {
            return {
                ...state,
                pricingStatus: 'loading',
            }
        },
        [updatePricingInformation.fulfilled]: (state, action) => {
            return {
                ...state,
                pricingStatus: 'succeeded',
            }
        },
        [updatePricingInformation.rejected]: (state, action) => {
            return {
                ...state,
                pricingStatus: 'failed',
                pricingError: action.error.message,
            }
        },
    }
});

export const { reset, editProduct, resetCreateProductStatus, editDistribution, editPricing, resetCreateProduct, resetProduct } = createProductSlice.actions;
export const selectCreateProduct = state => state.createProduct.createProduct;
export const selectCreateProductStatus = state => state.createProduct.createProductStatus;
export const selectCreateProductError = state => state.createProduct.createProductError;
export const selectDistribution = state => state.createProduct.distribution;
export const selectDistributionStatus = state => state.createProduct.distributionStatus;
export const selectDistributionError = state => state.createProduct.distributionError;
export const selectPricing = state => state.createProduct.pricing;
export const selectPricingStatus = state => state.createProduct.pricingStatus;
export const selectPricingError = state => state.createProduct.pricingError;
export default createProductSlice.reducer;
